import { useState } from "react";
import LegalDocumentLayout from "./LegalDocumentLayout";
import { LEGAL_LANGUAGE_DA, getLegalUiText, getTermsDocument } from "./legalDocuments";

export default function TermsOfServiceView() {
  const [language, setLanguage] = useState(LEGAL_LANGUAGE_DA);
  const document = getTermsDocument(language);

  return (
    <LegalDocumentLayout
      title={document.title}
      lastUpdated={document.lastUpdated}
      intro={document.intro}
      language={language}
      onLanguageChange={setLanguage}
      translationNotice={getLegalUiText(language).translationNotice}
    >
      {document.content}
    </LegalDocumentLayout>
  );
}